import { RootState } from '@/store/types'
import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { PronosticoLocalMapasState } from './types'

export const state: PronosticoLocalMapasState = {
  inicio: new Date().toISOString(),
  imagenes: {
    Precipitacion: []
  },
  pasos: 0,
  ruta: '',
  fecha_inicio_nieve: null,
  centro: [],
  latlong: [[]],
  delta: 0,
  etiquetas: {
    Precipitacion: 'Precipitaci&oacute;n'
  },
  error: { state: false }
}

const namespaced: boolean = true

export const pronosticoLocalMapas: Module<PronosticoLocalMapasState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
